function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m45.322 0.0074525a2.6658 2.6658 0 0 0-2.6628 2.6658c0 7.8619-6.886 10.664-13.33 10.664h-18.666a10.664 10.664 0 0 0-10.664 10.665v5.3315a10.609 10.609 0 0 0 4.0361 8.2885l9.5235 21.254a8.6197 8.6197 0 0 0 7.8677 5.1163 7.9505 7.9505 0 0 0 7.2561-11.196l-5.8653-12.799h6.5081c6.4438 0 13.33 2.8021 13.33 10.664a2.6662 2.6662 0 1 0 5.3325 0v-47.989a2.6658 2.6658 0 0 0-2.6658-2.6658zm-21.497 54.971a2.621 2.621 0 0 1-2.3989 3.6816 3.2842 3.2842 0 0 1-3.0018-1.9567l-7.4811-16.706h6.0094zm18.834-16.047a20.59 20.59 0 0 0-13.33-4.266h-18.666a5.3325 5.3325 0 0 1-5.3315-5.3315v-5.3325a5.3325 5.3325 0 0 1 5.3325-5.3325h18.661a20.59 20.59 0 0 0 13.334-4.2514zm21.058 2.2752a2.6658 2.6658 0 0 1-3.5774 1.1941l-5.3325-2.6658a2.6672 2.6672 0 1 1 2.3833-4.7725l5.3325 2.6658a2.6658 2.6658 0 0 1 1.1941 3.5647zm-10.104-23.998a2.6658 2.6658 0 0 1 1.1941-3.5774l5.3325-2.6658a2.6672 2.6672 0 1 1 2.3833 4.7725l-5.3325 2.6648a2.6658 2.6658 0 0 1-3.5774-1.1941zm-0.29219 9.4592a2.6658 2.6658 0 0 1 2.6658-2.6658h5.3325a2.6662 2.6662 0 1 1 0 5.3325h-5.3335a2.6658 2.6658 0 0 1-2.6658-2.6667z",
    fill: "currentColor",
    style: {
      strokeWidth: 0.97397
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.db4d53b4.svg";
export { ForwardRef as ReactComponent };